import styled from 'styled-components'

export default styled.div`
  color: #333;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  white-space: nowrap;
`
